import {
  DialogContent,
  Dialog,
  DialogProps,
  useEventCallback,
  DialogActions,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { PmiDialogTitle } from 'shell/components/shared/dialog/title';
import { styled } from '@mui/styles';
import { PmiButton } from 'shell/components/shared/button';
import { memo, useEffect } from 'react';
import { useFormik } from 'formik';
import Form from 'practice/components/detail/form/accordion-practice/form';
import { __PRACTICE_API_URL__ } from 'shell/constants/environment';
import { useHttpClient } from 'shell/hooks/use-http-fetch/stateless';
import { ResponsePromise } from 'shell/hooks/use-http-fetch/stateless/type';
import { noop } from 'shell/utils/noop';
import { AccordionPracticeVM } from 'practice/view-models/practice-detail';
import { HttpResponse } from 'shell/models/http-response';
import { PracticeData } from 'shell/models/practice';
import { transformerPraticeAccordionDetail } from 'practice/utils/practice-detail-transform';

export const PmiDialog = styled((props: DialogProps) => <Dialog {...props} />)((props) => ({
  '& .MuiDialog-paper': props.fullScreen
    ? {
        minWidth: 'unset',
        maxWidth: '100%',
      }
    : {
        minWidth: '50rem',
        maxWidth: '800px',
      },
}));

interface ModalConfirmMessiProps {
  open: boolean;
  onClose: (isConfirm: boolean) => void;
  codeEnte?: string;
  typeRegister?: string;
  yearId?: string;
  progressive?: string;
}

const ModalConfirmMessiComponent = ({
  open,
  onClose,
  codeEnte,
  typeRegister,
  yearId,
  progressive,
}: ModalConfirmMessiProps): React.ReactElement => {
  const data = useHttpClient(
    `${__PRACTICE_API_URL__}/pratiche/pratica/${codeEnte}-${yearId}-${typeRegister}-${progressive}`,
    {
      options: { method: 'GET' },
    }
  );

  const formContext = useFormik<AccordionPracticeVM>({
    initialValues: {},
    onSubmit: noop,
  });

  useEffect(() => {
    (data() as ResponsePromise<HttpResponse<PracticeData>>).then((response) => {
      const castedResponse = response?.data.payload as PracticeData;
      const castedData: AccordionPracticeVM | undefined =
        transformerPraticeAccordionDetail(castedResponse);

      if (castedData) {
        formContext.setValues(castedData);
      }
    });
  }, []);

  const onChange = useEventCallback(
    (key: keyof AccordionPracticeVM, value: AccordionPracticeVM[keyof AccordionPracticeVM]) => {
      formContext.setFieldValue(key, value);
    }
  );

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down(theme.breakpoints.values.md));

  return (
    <PmiDialog
      fullScreen={fullScreen}
      open={open}
      onClose={() => {
        onClose(false);
      }}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <PmiDialogTitle id="alert-dialog-title" backgroundColor="primary" color="white">
        {"Processo di apertura pratica - Si desidera confermare l'apertura della pratica?"}
      </PmiDialogTitle>
      <DialogContent style={{ padding: '30px 24px' }}>
        <Form values={formContext.values} disabled onChange={onChange} withoutDateClose />
      </DialogContent>
      <DialogActions>
        <PmiButton
          variant="contained"
          color="cdmBrand"
          onClick={() => {
            onClose(false);
          }}
        >
          Annulla
        </PmiButton>
        <PmiButton
          variant="contained"
          color="primary"
          onClick={() => {
            onClose(true);
          }}
        >
          Conferma
        </PmiButton>
      </DialogActions>
    </PmiDialog>
  );
};

ModalConfirmMessiComponent.displayName = 'Modal Confirm Messi Component';

const ModalConfirmMessi = memo(ModalConfirmMessiComponent);

export default ModalConfirmMessi;
